import * as THREE from 'three'
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js'
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js'

import gsap from "gsap";

// import Stats from 'stats.js';

import buildJSONScene1 from './scene1.json';
import buildJSONScene2 from './scene2.json';

let assetBaseURL = '/-/themes/app/renderer/dist/';

if (import.meta.env.PROD === false) {

    console.log('Running in DEV mode');

    assetBaseURL = '/';

    document.getElementById("scene1").addEventListener("click", function () {
        console.log('Scene 1 click');
        document.getElementById("renderdata").innerHTML = JSON.stringify(buildJSONScene1);
        document.getElementById("renderdata").setAttribute("data-version", "scene1");
    });
    document.getElementById("scene2").addEventListener("click", function () {
        console.log('Scene 2 click');
        document.getElementById("renderdata").innerHTML = JSON.stringify(buildJSONScene2);
        document.getElementById("renderdata").setAttribute("data-version", "scene2");
    });

    document.getElementById("renderdata").innerHTML = JSON.stringify(buildJSONScene1);
    document.getElementById("renderdata").setAttribute("data-version", "scene1");

} else {
    console.log('Running in PROD mode');
}

// const stats = new Stats()
// stats.showPanel(0) // 0: fps, 1: ms, 2: mb, 3+: custom
// document.body.appendChild(stats.dom)

//console.log('Asset base URL set to: ' + assetBaseURL);

let loadingOverlay = document.getElementById('loading-overlay');
loadingOverlay.classList.add('active');

/**
 * Base
 */

// Canvas
const canvas = document.querySelector('canvas.webgl')
const renderHolder = document.getElementById('configurator-view');

// Scene
const scene = new THREE.Scene();
window.ThreeScene = scene;

scene.background = new THREE.Color('#2B303A');

/**
 * Sizes
 */
const sizes = {
    width: renderHolder.offsetWidth,
    height: renderHolder.offsetHeight
};

/**
 * Camera
 */
const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 0
camera.position.y = 0
camera.position.z = 12
scene.add(camera);

window.ThreeCamera = camera;

let cameraInitialSetupComplete = false;

/**
 * Camera Controls
 */
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true;
controls.dampingFactor = 0.05;
controls.rotateSpeed = 0.1;
controls.enablePan = false;
controls.enableZoom = true;
controls.maxDistance = 10;
controls.minDistance = 20;

// const axesHelper = new THREE.AxesHelper(100)
// scene.add(axesHelper)

let removableGeometries = [];
let removableMeshes = [];
let removableMaterials = [];
let removableTextures = [];
let removableObjects = [];
let removableLights = [];

/**
 * Texture Loader
 */
const textureLoader = new THREE.TextureLoader()

/**
 * Model Loader
 */
const gltfLoader = new GLTFLoader();

let essentialModelsLoaded = false;
let lazyLoadedRedrawNeeded = false;
let initialLoadDone = false;

let conferenceTableClean = undefined;
let conferenceTableBrick = undefined;

gltfLoader.load(
    assetBaseURL + 'models/NewDesks/Compressed/Conference2/conference2-opt.glb',
    (gltf) => {
        conferenceTableBrick = gltf.scene;
        conferenceTableClean = gltf.scene;
        lazyLoadedRedrawNeeded = true;
    }
);

let smallDeskClean = undefined;
let smallDeskBrick = undefined;

gltfLoader.load(
    assetBaseURL + 'models/NewDesks/Compressed/SmallDesk2/desk1-opt.glb',
    (gltf) => {
        smallDeskBrick = gltf.scene;
        smallDeskClean = gltf.scene;
        lazyLoadedRedrawNeeded = true;
    }
);

const ironmongeryMaterial = new THREE.MeshPhongMaterial();

let dHandle600 = undefined;
let dHandle1000 = undefined;
let guardsmanHandle750 = undefined;
let guardsmanHandle1200 = undefined;
let guardsmanCrankedHandle720 = undefined;
let guardsmanCrankedHandle1240 = undefined;
let dHandleCranked600 = undefined;
let dHandleCranked1000 = undefined;
let leverHandleTimber = undefined;
let leverHandleFramed = undefined;
let leverHandleGlass = undefined;
let leverHandleGlassStrikerBox = undefined;
let buttHinge = undefined;
let plateHinge = undefined;
let topPivot = undefined;
let bottomPivot = undefined;
let pivotFrameLeft = undefined;
let pivotFrameRight = undefined;
let slidingDoorRail = undefined;
let doorCloserTimber = undefined;
let doorCloserHidden = undefined;
let mgoLogoManifestation = undefined;

gltfLoader.load(
    assetBaseURL + 'models/DoorHandleRenders/DHandle600/DHandle600.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        dHandle600 = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorHandleRenders/DHandle1000/DHandle1000.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        dHandle1000 = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorHandleRenders/GuardsmanHandle750/GuardsmanHandle750.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        guardsmanHandle750 = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorHandleRenders/GuardsmanHandle1200/GuardsmanHandle1200.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        guardsmanHandle1200 = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorHandleRenders/GuardsmanCrankedHandle720/GuardsmanCrankedHandle720.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        guardsmanCrankedHandle720 = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorHandleRenders/GuardsmanCrankedHandle1240/GuardsmanCrankedHandle1240.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        guardsmanCrankedHandle1240 = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorHandleRenders/DHandleCranked600/DHandleCranked600.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        dHandleCranked600 = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorHandleRenders/DHandleCranked1000/DHandleCranked1000.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        dHandleCranked1000 = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorHandleRenders/LeverHandleFramed/LeverHandleFramed.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        leverHandleFramed = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorHandleRenders/LeverHandleTimber/LeverHandleTimber.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        leverHandleTimber = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorHandleRenders/LeverHandleGlass/LeverHandleGlass.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        leverHandleGlass = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorHandleRenders/LeverHandleGlassStrikerBox/LeverHandleGlassStrikerBox.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        leverHandleGlassStrikerBox = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorHingeRenders/ButtHinge/ButtHinge.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        buttHinge = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorHingeRenders/PlateHinge/PlateHinge.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        plateHinge = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorHingeRenders/TopPivot/TopPivot.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        topPivot = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorHingeRenders/BottomPivot/BottomPivot.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        bottomPivot = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorHingeRenders/PivotFrameLeft/PivotFrameLeft.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        pivotFrameLeft = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorHingeRenders/PivotFrameRight/PivotFrameRight.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        pivotFrameRight = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorHingeRenders/SlidingDoorRail/SlidingDoorRail.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = railMaterial;
            child.material.needsUpdate = true;
        });

        slidingDoorRail = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorCloserRenders/DoorCloserTimber/DoorCloserTimber.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        doorCloserTimber = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/DoorCloserRenders/DoorCloserHidden/DoorCloserHidden.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = ironmongeryMaterial;
            child.material.needsUpdate = true;
        });

        doorCloserHidden = gltf.scene;
    }
);

gltfLoader.load(
    assetBaseURL + 'models/MgoLogoCutoutLarge/MGOLogoCutoutIcon.gltf',
    (gltf) => {
        gltf.scene.traverse(function (child) {
            child.material = frostedGlassMaterial;
            child.material.needsUpdate = true;
        });

        mgoLogoManifestation = gltf.scene;
    }
);

/**
 * Textures & Materials
 */
let floorCleanColorTextureLoaded = undefined;
const floorCleanColorTexture = textureLoader.load(
    assetBaseURL + 'textures/clean/wood_floor_diff_4k.jpg',
    (texture) => {
        floorCleanColorTextureLoaded = true
    }
);

floorCleanColorTexture.wrapS = THREE.RepeatWrapping;
floorCleanColorTexture.wrapT = THREE.RepeatWrapping;
floorCleanColorTexture.repeat.set(24, 24);
floorCleanColorTexture.colorSpace = THREE.SRGBColorSpace

let floorBrickColorTextureLoaded = undefined;
const floorBrickColorTexture = textureLoader.load(
    assetBaseURL + 'textures/brick/PolishedConcrete01_2K_BaseColor.png',
    (texture) => {
        floorBrickColorTextureLoaded = true
    }
)
floorBrickColorTexture.wrapS = THREE.RepeatWrapping;
floorBrickColorTexture.wrapT = THREE.RepeatWrapping;
floorBrickColorTexture.repeat.set(1, 1);
floorBrickColorTexture.colorSpace = THREE.SRGBColorSpace;

const floorMaterial = new THREE.MeshStandardMaterial({
    map: floorBrickColorTexture,
});

let wallBrickColorTextureLoaded = undefined;
const wallBrickColorTexture = textureLoader.load(
    assetBaseURL + 'textures/brick/ConcreteBare0355_1_500-lightened.jpg',
    (texture) => {
        wallBrickColorTextureLoaded = true
    }
)

wallBrickColorTexture.wrapS = THREE.RepeatWrapping;
wallBrickColorTexture.wrapT = THREE.RepeatWrapping;
wallBrickColorTexture.repeat.set(16, 16);
wallBrickColorTexture.colorSpace = THREE.SRGBColorSpace;

let wallCleanColorTextureLoaded = undefined;
const wallCleanColorTexture = textureLoader.load(
    assetBaseURL + 'textures/clean/white-wall-textures-darkened.jpg',
    (texture) => {
        wallCleanColorTextureLoaded = true
    }
)

wallCleanColorTexture.wrapS = THREE.RepeatWrapping;
wallCleanColorTexture.wrapT = THREE.RepeatWrapping;
wallCleanColorTexture.repeat.set(16, 16);
wallCleanColorTexture.colorSpace = THREE.SRGBColorSpace;

const wallMaterial = new THREE.MeshStandardMaterial();

let ceilingBrickColorTextureLoaded = undefined;
const ceilingBrickColorTexture = textureLoader.load(
    assetBaseURL + 'textures/brick/ConcreteBare0355_1_500-darkened.jpg',
    (texture) => {
        ceilingBrickColorTextureLoaded = true
    }
)
ceilingBrickColorTexture.wrapS = THREE.RepeatWrapping;
ceilingBrickColorTexture.wrapT = THREE.RepeatWrapping;
ceilingBrickColorTexture.colorSpace = THREE.SRGBColorSpace;

let ceilingCleanColorTextureLoaded = undefined;
const ceilingCleanColorTexture = textureLoader.load(
    assetBaseURL + 'textures/clean/plastered_wall_diff_4k-lightened.jpg',
    (texture) => {
        ceilingCleanColorTextureLoaded = true
    }
)
ceilingCleanColorTexture.wrapS = THREE.RepeatWrapping;
ceilingCleanColorTexture.wrapT = THREE.RepeatWrapping;
ceilingCleanColorTexture.colorSpace = THREE.SRGBColorSpace;

const ceilingMaterial = new THREE.MeshStandardMaterial({
    map: ceilingBrickColorTexture,
});

const glassPanelMaterial = new THREE.MeshPhysicalMaterial({
    roughness: 0,
    transmission: 0.95,
    thickness: 1,
    reflectivity: 0,
    color: '#ffffff',
    transparent: true
});

const hingeMaterial = new THREE.MeshPhongMaterial();
hingeMaterial.color = new THREE.Color('#c9cccd');
hingeMaterial.specular = new THREE.Color('#e4e6e6');
hingeMaterial.emissive = new THREE.Color('#656667');

let oakDoorMapTextureLoaded = undefined;
const oakDoorMapTexture = textureLoader.load(
    assetBaseURL + 'textures/newdoors/oak/BaseColor.png',
    (texture) => {
        oakDoorMapTextureLoaded = true
    }
);
oakDoorMapTexture.colorSpace = THREE.SRGBColorSpace;

const oakDoorMaterial = new THREE.MeshPhysicalMaterial({
    map: oakDoorMapTexture,
    color: new THREE.Color('#ffffff'),
    metalness: 0,
    clearcoat: 1,
    reflectivity: 1
});

let mapleDoorMapTextureLoaded = undefined;
const mapleDoorMapTexture = textureLoader.load(
    assetBaseURL + 'textures/newdoors/maple/BaseColor.png',
    (texture) => {
        mapleDoorMapTextureLoaded = true
    }
);
mapleDoorMapTexture.colorSpace = THREE.SRGBColorSpace;

const mapleDoorMaterial = new THREE.MeshPhysicalMaterial({
    map: mapleDoorMapTexture,
    color: new THREE.Color('#ffffff'),
    metalness: 0,
    clearcoat: 1,
    reflectivity: 1
});

let walnutDoorMapTextureLoaded = undefined;
const walnutDoorMapTexture = textureLoader.load(
    assetBaseURL + 'textures/newdoors/walnut/BaseColor.png',
    (texture) => {
        walnutDoorMapTextureLoaded = true
    }
);
walnutDoorMapTexture.colorSpace = THREE.SRGBColorSpace;

const walnutDoorMaterial = new THREE.MeshPhysicalMaterial({
    map: walnutDoorMapTexture,
    color: new THREE.Color('#ffffff'),
    metalness: 0,
    clearcoat: 1,
    reflectivity: 1
});

const colorTimberDoorMaterial = new THREE.MeshPhysicalMaterial({
    color: new THREE.Color('#ffffff'),
    metalness: 0,
    clearcoat: 1,
    reflectivity: 1
});

const railMaterial = new THREE.MeshPhysicalMaterial({
    metalness: 0,
    color: '#c0c0c0'
});

const frostedGlassMaterial = new THREE.MeshPhysicalMaterial({
    roughness: 0.22,
    transmission: 0.44,
    thickness: 0,
    color: '#eeeeee',
    transparent: true
});
frostedGlassMaterial.side = THREE.DoubleSide;

const leafGlassMaterial = new THREE.MeshPhysicalMaterial({
    roughness: 0,
    transmission: 1,
    thickness: 0,
    color: '#eeeeee',
    transparent: true
});
leafGlassMaterial.side = THREE.DoubleSide;

let posterColorTextureLoaded = undefined;
const posterColorTexture = textureLoader.load(
    assetBaseURL + 'textures/poster/mgo-logo-dark.png',
    (texture) => {
        posterColorTextureLoaded = true
    }
)
const posterMaterial = new THREE.MeshStandardMaterial({map: posterColorTexture});

/**
 * Ambient Light
 */
const ambientLight = new THREE.AmbientLight('#ffffff', 0.7)
scene.add(ambientLight)


let reededFilmTextureLoaded = undefined;
const reededFilmTexture = textureLoader.load(
    assetBaseURL + 'textures/flutedglass/stripetexture.jpg',
    (texture) => {
        reededFilmTextureLoaded = true
    }
)
const reededFilmMaterial = new THREE.MeshPhysicalMaterial({
    roughness: 0.86,
    transmission: 1,
    thickness: 0.15,
    color: '#ffffff',
    alphaMap: reededFilmTexture,
    normalMap: reededFilmTexture,
    transparent: true,
    reflectivity: 0.18
});

reededFilmMaterial.side = THREE.DoubleSide;
reededFilmMaterial.normalMap.wrapS = reededFilmMaterial.normalMap.wrapT = THREE.RepeatWrapping;

let buildSceneFromJSON = function () {
//    console.log('Building Scene');

    /**
     * Camera
     */
     if (buildJSON.camera !== undefined) {
         if (buildJSON.camera.updatecamera === true || cameraInitialSetupComplete === false) {

             let cameraEase = "power1.out";
             let cameraAnimationDuration = 1;
             let zoomAnimationDuration = 2;

             if (cameraInitialSetupComplete === false) {
                 cameraAnimationDuration = 0
             }

             gsap.to(camera.position, {
                 ease: cameraEase,
                 duration: cameraAnimationDuration,
                 x: buildJSON.camera.position.x,
                 y: buildJSON.camera.position.y,
                 z: buildJSON.camera.position.z,
             });

             gsap.to(controls.target, {
                 ease: cameraEase,
                 duration: cameraAnimationDuration,
                 x: buildJSON.camera.centre.x,
                 y: buildJSON.camera.centre.y,
                 z: buildJSON.camera.centre.z,
             });

             controls.enableZoom = false;

             gsap.to(controls, {
                 ease: cameraEase,
                 duration: zoomAnimationDuration,
                 maxDistance: buildJSON.camera.zoom.initialzoom,
                 minDistance: buildJSON.camera.zoom.initialzoom,
                 onComplete: function () {

                     controls.update();
                     controls.minPolarAngle = buildJSON.camera.limits.minpolarangle;
                     controls.maxPolarAngle = buildJSON.camera.limits.maxpolarangle;
                     controls.minAzimuthAngle = buildJSON.camera.limits.minazimuthangle;
                     controls.maxAzimuthAngle = buildJSON.camera.limits.maxazimuthangle;
                     controls.maxDistance = buildJSON.camera.zoom.maxzoom;
                     controls.minDistance = buildJSON.camera.zoom.minzoom;
                     controls.enableZoom = buildJSON.camera.zoom.enabled;
                 }
             });

             cameraInitialSetupComplete = true;
         }
     }

    /**
     * Deal with any global changes to the config
     */
    if (buildJSON.office.globals !== undefined) {
        if (buildJSON.office.globals.frameworkcolour !== undefined) {
            railMaterial.color.set(buildJSON.office.globals.frameworkcolour);
        }

        if (buildJSON.office.globals.ambientlight !== undefined) {
            ambientLight.color.set(buildJSON.office.globals.ambientlight.color);
            ambientLight.intensity = buildJSON.office.globals.ambientlight.intensity;
        }

        if (buildJSON.office.globals.ironmongerycolour !== undefined) {

            switch (buildJSON.office.globals.ironmongerycolour) {
                case 'steel':
                    ironmongeryMaterial.color = new THREE.Color('#c9cccd');
                    ironmongeryMaterial.specular = new THREE.Color('#e4e6e6');
                    ironmongeryMaterial.emissive = new THREE.Color('#656667');
                    break;
                case 'bronze':
                    ironmongeryMaterial.shininess = 100
                    ironmongeryMaterial.color = new THREE.Color('#A4844F');
                    ironmongeryMaterial.specular = new THREE.Color('#FAECE0');
                    ironmongeryMaterial.emissive = new THREE.Color('#5F3F0A');
                    break;
                case 'black':
                    ironmongeryMaterial.shininess = 50
                    ironmongeryMaterial.color = new THREE.Color('#222222');
                    ironmongeryMaterial.specular = new THREE.Color('#575757');
                    ironmongeryMaterial.emissive = new THREE.Color('#050505');
                    break;
                default:
            }

        }
    }

    /**
     * Scene Floor
     */
    if (buildJSON.scene.floor !== undefined) {
        const floorGeometry = new THREE.BoxGeometry(buildJSON.scene.floor.size.width, buildJSON.scene.floor.size.height, buildJSON.scene.floor.size.depth)
        removableGeometries.push(floorGeometry.uuid);

        let height = buildJSON.scene.floor.size.depth;
        let width = buildJSON.scene.floor.size.width;

        let newFloorMaterial = floorMaterial.clone();
        removableMaterials.push(newFloorMaterial.uuid);

        let newFloorColorTexture = floorCleanColorTexture.clone();
        removableTextures.push(newFloorColorTexture.uuid);

        //Negating this test, because the client has decided to swap the floors, and this is the simplest way!
        if (buildJSON.scene.floor.style !== 'brick') {
            newFloorColorTexture = floorBrickColorTexture.clone();
            removableTextures.push(newFloorColorTexture.uuid);
        }
        newFloorMaterial.map = newFloorColorTexture;

        newFloorColorTexture.repeat.set(width / 4 , height / 4);
        newFloorColorTexture.needsUpdate = true;

        const floorMesh = new THREE.Mesh(floorGeometry, newFloorMaterial)
        floorMesh.position.x = buildJSON.scene.floor.position.x;
        floorMesh.position.y = buildJSON.scene.floor.position.y;
        floorMesh.position.z = buildJSON.scene.floor.position.z;
        scene.add(floorMesh)
        removableMeshes.push(floorMesh.uuid);
    }

    /**
     * Scene Ceiling
     */
    if (buildJSON.scene.ceiling !== undefined) {
        const ceilingGeometry = new THREE.PlaneGeometry(buildJSON.scene.ceiling.size.width, buildJSON.scene.ceiling.size.depth);
        removableGeometries.push(ceilingGeometry.uuid);

        let height = buildJSON.scene.ceiling.size.depth;
        let width = buildJSON.scene.ceiling.size.width;

        let newCeilingMaterial = ceilingMaterial.clone();
        removableMaterials.push(newCeilingMaterial.uuid);

        let newCeilingColorTexture = ceilingCleanColorTexture.clone();
        removableTextures.push(newCeilingColorTexture.uuid);

        if (buildJSON.scene.ceiling.style === 'brick') {
            newCeilingColorTexture = ceilingBrickColorTexture.clone();
            removableTextures.push(newCeilingColorTexture.uuid);
        }
        newCeilingMaterial.map = newCeilingColorTexture;

        newCeilingColorTexture.repeat.set(width / 0.5 , height / 0.5);
        newCeilingColorTexture.needsUpdate = true;

        const ceilingMesh = new THREE.Mesh(ceilingGeometry, newCeilingMaterial)
        ceilingMesh.position.x = buildJSON.scene.ceiling.position.x;
        ceilingMesh.position.y = buildJSON.scene.ceiling.position.y;
        ceilingMesh.position.z = buildJSON.scene.ceiling.position.z;
        ceilingMesh.rotation.x = Math.PI * 0.5;
        scene.add(ceilingMesh)
        removableMeshes.push(ceilingMesh.uuid);
    }

    /**
     * Scene Walls
     */
    if (buildJSON.scene.walls !== undefined) {
        for (let wallKey in buildJSON.scene.walls) {
            let wall = buildJSON.scene.walls[wallKey];
            const wallGeometry = new THREE.BoxGeometry(wall.size.width, wall.size.height, wall.size.depth)
            removableGeometries.push(wallGeometry.uuid);

            let height = wall.size.height;
            let width = Math.max(wall.size.width, wall.size.depth);

            let newWallMaterial = wallMaterial.clone();
            removableMaterials.push(newWallMaterial.uuid);

            let newWallColorTexture = wallCleanColorTexture.clone();
            removableTextures.push(newWallColorTexture.uuid);

            if (wall.style === 'brick') {
                newWallColorTexture = wallBrickColorTexture.clone();
                removableTextures.push(newWallColorTexture.uuid);
            }
            newWallMaterial.map = newWallColorTexture;

            newWallColorTexture.repeat.set(width / 0.5 , height / 0.5);
            newWallColorTexture.needsUpdate = true;

            const wallMesh = new THREE.Mesh(wallGeometry, newWallMaterial);
            wallMesh.position.x = wall.position.x;
            wallMesh.position.y = wall.position.y;
            wallMesh.position.z = wall.position.z;
            scene.add(wallMesh)
            removableMeshes.push(wallMesh.uuid);
        }
    }

    /**
     * Partition Walls
     */
    if (buildJSON.office.glass !== undefined) {
        for (let glassKey in buildJSON.office.glass) {
            let glassWall = buildJSON.office.glass[glassKey];
            const glassWallGeometry = new THREE.BoxGeometry(glassWall.size.width, glassWall.size.height, glassWall.size.depth)
            removableGeometries.push(glassWallGeometry.uuid);

            const glassWallMesh = new THREE.Mesh(glassWallGeometry, glassPanelMaterial)
            glassWallMesh.position.x = glassWall.position.x;
            glassWallMesh.position.y = glassWall.position.y;
            glassWallMesh.position.z = glassWall.position.z;
            scene.add(glassWallMesh)
            removableMeshes.push(glassWallMesh.uuid);
        }
    }

    /**
     * Top Rails
     */
    if (buildJSON.office.topRails !== undefined) {
        for (let topRailKey in buildJSON.office.topRails) {
            let topRail = buildJSON.office.topRails[topRailKey];
            const topRailGeometry = new THREE.BoxGeometry(topRail.size.width, topRail.size.height, topRail.size.depth)
            removableGeometries.push(topRailGeometry.uuid);

            const topRailMesh = new THREE.Mesh(topRailGeometry, railMaterial)
            topRailMesh.position.x = topRail.position.x;
            topRailMesh.position.y = topRail.position.y;
            topRailMesh.position.z = topRail.position.z;
            scene.add(topRailMesh)
            removableMeshes.push(topRailMesh.uuid);
        }
    }

    /**
     * Bottom Rails
     */
    if (buildJSON.office.bottomRails !== undefined) {
        for (let bottomRailKey in buildJSON.office.bottomRails) {
            let bottomRail = buildJSON.office.bottomRails[bottomRailKey];
            const bottomRailGeometry = new THREE.BoxGeometry(bottomRail.size.width, bottomRail.size.height, bottomRail.size.depth)
            removableGeometries.push(bottomRailGeometry.uuid);

            const bottomRailMesh = new THREE.Mesh(bottomRailGeometry, railMaterial)
            bottomRailMesh.position.x = bottomRail.position.x;
            bottomRailMesh.position.y = bottomRail.position.y;
            bottomRailMesh.position.z = bottomRail.position.z;
            scene.add(bottomRailMesh)
            removableMeshes.push(bottomRailMesh.uuid);
        }
    }

    /**
     * Vertical Rails
     */
    if (buildJSON.office.verticalRails !== undefined) {
        for (let verticalRailKey in buildJSON.office.verticalRails) {
            let verticalRail = buildJSON.office.verticalRails[verticalRailKey];
            const verticalRailGeometry = new THREE.BoxGeometry(verticalRail.size.width, verticalRail.size.height, verticalRail.size.depth)
            removableGeometries.push(verticalRailGeometry.uuid);

            const verticalRailMesh = new THREE.Mesh(verticalRailGeometry, railMaterial)
            verticalRailMesh.position.x = verticalRail.position.x;
            verticalRailMesh.position.y = verticalRail.position.y;
            verticalRailMesh.position.z = verticalRail.position.z;
            scene.add(verticalRailMesh)
            removableMeshes.push(verticalRailMesh.uuid);
        }
    }

    /**
     * Abutments
     */
    if (buildJSON.office.abutments !== undefined) {
        for (let abutmentKey in buildJSON.office.abutments) {
            let abutment = buildJSON.office.abutments[abutmentKey];
            const abutmentGeometry = new THREE.BoxGeometry(abutment.size.width, abutment.size.height, abutment.size.depth)
            removableGeometries.push(abutmentGeometry.uuid);

            const abutmentMesh = new THREE.Mesh(abutmentGeometry, railMaterial)
            abutmentMesh.position.x = abutment.position.x;
            abutmentMesh.position.y = abutment.position.y;
            abutmentMesh.position.z = abutment.position.z;
            scene.add(abutmentMesh)
            removableMeshes.push(abutmentMesh.uuid);
        }
    }

    /**
     * Doors
     */
    for (let doorKey in buildJSON.office.doors) {

        let door = buildJSON.office.doors[doorKey];

        for (let frameKey in door.frame) {
            let frame = door.frame[frameKey];
            const frameGeometry = new THREE.BoxGeometry(frame.size.width, frame.size.height, frame.size.depth)
            removableGeometries.push(frameGeometry.uuid);

            const frameMesh = new THREE.Mesh(frameGeometry, railMaterial)
            frameMesh.position.x = frame.position.x;
            frameMesh.position.y = frame.position.y;
            frameMesh.position.z = frame.position.z;
            scene.add(frameMesh)
            removableMeshes.push(frameMesh.uuid);
        }

        if (door.leaf !== undefined) {

            if (
                door.leaf.type === 'timber' ||
                door.leaf.type === 'oak' ||
                door.leaf.type === 'maple' ||
                door.leaf.type === 'walnut' ||
                door.leaf.type === 'timberblack' ||
                door.leaf.type === 'timberwhite' ||
                door.leaf.type === 'timbergrey'
            ) {
                const timberDoorGeometry = new THREE.BoxGeometry(door.leaf.size.width, door.leaf.size.height, door.leaf.size.depth)
                removableGeometries.push(timberDoorGeometry.uuid);

                const timberDoorMesh = new THREE.Mesh(timberDoorGeometry, oakDoorMaterial);

                if (door.leaf.type === 'oak') {
                    const timberDoorMesh = new THREE.Mesh(timberDoorGeometry, oakDoorMaterial);
                    timberDoorMesh.material = oakDoorMaterial;
                }

                if (door.leaf.type === 'maple') {
                    timberDoorMesh.material = mapleDoorMaterial;
                }

                if (door.leaf.type === 'walnut') {
                    timberDoorMesh.material = walnutDoorMaterial;
                }

                if (door.leaf.type === 'timberblack') {
                    colorTimberDoorMaterial.color = new THREE.Color('#0e0e10')
                    timberDoorMesh.material = colorTimberDoorMaterial;
                }

                if (door.leaf.type === 'timberwhite') {
                    colorTimberDoorMaterial.color = new THREE.Color('#ffffff')
                    timberDoorMesh.material = colorTimberDoorMaterial;
                }

                if (door.leaf.type === 'timbergrey') {
                    colorTimberDoorMaterial.color = new THREE.Color('#a1a1a0')
                    timberDoorMesh.material = colorTimberDoorMaterial;
                }

                timberDoorMesh.position.x = door.leaf.position.x;
                timberDoorMesh.position.y = door.leaf.position.y;
                timberDoorMesh.position.z = door.leaf.position.z;
                scene.add(timberDoorMesh)
                removableMeshes.push(timberDoorMesh.uuid);
            }

            if (door.leaf.type === 'sonik' || door.leaf.type === 'frameless') {

                let leafFrameThickness = 0.07;
                let leafMaterial = railMaterial;

                if (door.leaf.type === 'frameless') {
                    leafFrameThickness = 0.01;
                    leafMaterial = leafGlassMaterial;
                }

                const leafFrameTopRailGeometry = new THREE.BoxGeometry(door.leaf.size.width, leafFrameThickness, door.leaf.size.depth)
                removableGeometries.push(leafFrameTopRailGeometry.uuid);

                const leafFrameTopRailMesh = new THREE.Mesh(leafFrameTopRailGeometry, leafMaterial)
                leafFrameTopRailMesh.position.y = door.leaf.position.y + ((door.leaf.size.height / 2) + (leafFrameThickness / 2));
                leafFrameTopRailMesh.position.z = door.leaf.position.z;
                leafFrameTopRailMesh.position.x = door.leaf.position.x;
                leafFrameTopRailMesh.translateY(-leafFrameThickness);
                scene.add(leafFrameTopRailMesh)
                removableMeshes.push(leafFrameTopRailMesh.uuid);

                const leafFrameBottomRailGeometry = new THREE.BoxGeometry(door.leaf.size.width, leafFrameThickness, door.leaf.size.depth)
                removableGeometries.push(leafFrameBottomRailGeometry.uuid);

                const leafFrameBottomRailMesh = new THREE.Mesh(leafFrameBottomRailGeometry, leafMaterial)
                leafFrameBottomRailMesh.position.y = door.leaf.position.y - ((door.leaf.size.height / 2) + (leafFrameThickness / 2));
                leafFrameBottomRailMesh.position.z = door.leaf.position.z;
                leafFrameBottomRailMesh.position.x = door.leaf.position.x;
                leafFrameBottomRailMesh.translateY(leafFrameThickness);
                scene.add(leafFrameBottomRailMesh)
                removableMeshes.push(leafFrameBottomRailMesh.uuid);

                const leafFrameLeftRailGeometry = new THREE.BoxGeometry(leafFrameThickness, door.leaf.size.height, door.leaf.size.depth)
                removableGeometries.push(leafFrameLeftRailGeometry.uuid);

                const leafFrameLeftRailMesh = new THREE.Mesh(leafFrameLeftRailGeometry, leafMaterial)
                leafFrameLeftRailMesh.position.y = door.leaf.size.height / 2;
                leafFrameLeftRailMesh.position.z = door.leaf.position.z;
                leafFrameLeftRailMesh.position.x = door.leaf.position.x - ((door.leaf.size.width / 2) + (leafFrameThickness / 2));
                leafFrameLeftRailMesh.translateX(leafFrameThickness);
                scene.add(leafFrameLeftRailMesh)
                removableMeshes.push(leafFrameLeftRailMesh.uuid);

                const leafFrameRightRailGeometry = new THREE.BoxGeometry(leafFrameThickness, door.leaf.size.height, door.leaf.size.depth)
                removableGeometries.push(leafFrameRightRailGeometry.uuid);

                const leafFrameRightRailMesh = new THREE.Mesh(leafFrameRightRailGeometry, leafMaterial)
                leafFrameRightRailMesh.position.y = door.leaf.size.height / 2;
                leafFrameRightRailMesh.position.z = door.leaf.position.z;
                leafFrameRightRailMesh.position.x = door.leaf.position.x + ((door.leaf.size.width / 2) + (leafFrameThickness / 2));
                leafFrameRightRailMesh.translateX(-leafFrameThickness);
                scene.add(leafFrameRightRailMesh)
                removableMeshes.push(leafFrameRightRailMesh.uuid);
            }

        }

        if (door.handle !== undefined) {

            const doorHandleScale = 1;
            let thisHandle = undefined;

            switch (door.handle.type) {
                case 'GuardsmanHandle750':
                    thisHandle = guardsmanHandle750.clone();
                    break;
                case 'GuardsmanHandle1200':
                    thisHandle = guardsmanHandle1200.clone();
                    break;
                case 'GuardsmanCrankedHandle720':
                    thisHandle = guardsmanCrankedHandle720.clone();
                    break;
                case 'GuardsmanCrankedHandle1240':
                    thisHandle = guardsmanCrankedHandle1240.clone();
                    break;
                case 'DHandleCranked600':
                    thisHandle = dHandleCranked600.clone();
                    break;
                case 'DHandleCranked1000':
                    thisHandle = dHandleCranked1000.clone();
                    break;
                case 'LeverHandleTimber':
                    thisHandle = leverHandleTimber.clone();
                    break;
                case 'LeverHandleFramed':
                    thisHandle = leverHandleFramed.clone();
                    break;
                case 'LeverHandleGlass':
                    thisHandle = leverHandleGlass.clone();
                    break;
                case 'DHandle600':
                    thisHandle = dHandle600.clone();
                    break;
                case 'DHandle1000':
                    thisHandle = dHandle1000.clone();
                    break;
                default:
            }

            if (thisHandle !== undefined) {
                thisHandle.scale.set(doorHandleScale, doorHandleScale, doorHandleScale)
                thisHandle.position.x = door.handle.position.x;
                thisHandle.position.z = door.handle.position.z;
                thisHandle.position.y = door.handle.position.y;
                thisHandle.rotation.y = Math.PI;
                scene.add(thisHandle);
                removableObjects.push(thisHandle.uuid);
            }
        }

        if (door.hardware !== undefined) {

            for (let hardwareKey in door.hardware) {
                let hardware = door.hardware[hardwareKey];
                let thisHardware = undefined;

                const doorHardwareScale = 1;

                switch (hardware.type) {
                    case 'DoorCloserTimber':
                        thisHardware = doorCloserTimber.clone();
                        break;
                    case 'DoorCloserHidden':
                        thisHardware = doorCloserHidden.clone();
                        break;
                    case 'LeverHandleGlassStrikerBox':
                        thisHardware = leverHandleGlassStrikerBox.clone();
                        break;
                    case 'ButtHinge':
                        thisHardware = buttHinge.clone();
                        break;
                    case 'PlateHinge':
                        thisHardware = plateHinge.clone();
                        break;
                    case 'TopPivot':
                        thisHardware = topPivot.clone();
                        break;
                    case 'BottomPivot':
                        thisHardware = bottomPivot.clone();
                        break;
                    case 'PivotFrameLeft':
                        thisHardware = pivotFrameLeft.clone();
                        break;
                    case 'PivotFrameRight':
                        thisHardware = pivotFrameRight.clone();
                        break;
                    case 'SlidingDoorRail':
                        thisHardware = slidingDoorRail.clone();
                        break;
                    default:
                }

                if (thisHardware !== undefined) {
                    thisHardware.scale.set(doorHardwareScale, doorHardwareScale, doorHardwareScale)
                    thisHardware.position.x = hardware.position.x;
                    thisHardware.position.z = hardware.position.z;
                    thisHardware.position.y = hardware.position.y;
                    scene.add(thisHardware);
                    removableObjects.push(thisHardware.uuid);
                }

            }

        }

    }

    /**
     * Manifestations
     */
    if (buildJSON.office.manifestations !== undefined) {
        /**
         * Bands
         */
        if (buildJSON.office.manifestations.bands !== undefined) {
            for (let bandsKey in buildJSON.office.manifestations.bands) {
                let band = buildJSON.office.manifestations.bands[bandsKey];
                const bandGeometry = new THREE.BoxGeometry(band.size.width, band.size.height, band.size.depth)
                removableGeometries.push(bandGeometry.uuid);

                const bandMesh = new THREE.Mesh(bandGeometry, railMaterial)
                bandMesh.position.x = band.position.x;
                bandMesh.position.y = band.position.y;
                bandMesh.position.z = band.position.z;
                scene.add(bandMesh)
                removableMeshes.push(bandMesh.uuid);
            }
        }

        /**
         * Dots
         */
        if (buildJSON.office.manifestations.dots !== undefined) {
            for (let dotsKey in buildJSON.office.manifestations.dots) {
                let dot = buildJSON.office.manifestations.dots[dotsKey];
                const dotGeometry = new THREE.CylinderGeometry(dot.size.radius, dot.size.radius, dot.size.depth);
                removableGeometries.push(dotGeometry.uuid);

                const dotMesh = new THREE.Mesh(dotGeometry, frostedGlassMaterial)
                dotMesh.position.x = dot.position.x;
                dotMesh.position.y = dot.position.y;
                dotMesh.position.z = dot.position.z;
                dotMesh.rotation.x = dot.rotation.x;
                dotMesh.rotation.y = dot.rotation.y;
                dotMesh.rotation.z = dot.rotation.z;
                scene.add(dotMesh)
                removableMeshes.push(dotMesh.uuid);
            }
        }

        /**
         * Squares
         */
        if (buildJSON.office.manifestations.squares !== undefined) {
            for (let squaresKey in buildJSON.office.manifestations.squares) {
                let square = buildJSON.office.manifestations.squares[squaresKey];
                const squareGeometry = new THREE.BoxGeometry(square.size.width, square.size.height, square.size.depth)
                removableGeometries.push(squareGeometry.uuid);

                const squareMesh = new THREE.Mesh(squareGeometry, frostedGlassMaterial)
                squareMesh.position.x = square.position.x;
                squareMesh.position.y = square.position.y;
                squareMesh.position.z = square.position.z;
                scene.add(squareMesh);
                removableMeshes.push(squareMesh.uuid);
            }
        }

        /**
         * Reeded
         */
        if (buildJSON.office.manifestations.reeded !== undefined) {
            for (let reededKey in buildJSON.office.manifestations.reeded) {
                let reeded = buildJSON.office.manifestations.reeded[reededKey];
                const reededGeometry = new THREE.BoxGeometry(reeded.size.width, reeded.size.height, reeded.size.depth)
                removableGeometries.push(reededGeometry.uuid);

                let height = reeded.size.height;
                let width = Math.max(reeded.size.width, reeded.size.depth);
                let newReededMaterial = reededFilmMaterial.clone();
                removableMaterials.push(newReededMaterial.uuid);

                let newReededFilmTexture = reededFilmTexture.clone();
                removableTextures.push(newReededFilmTexture.uuid);

                newReededMaterial.alphaMap = newReededFilmTexture;
                newReededFilmTexture.repeat.set(width / 0.5 , height / 0.5);
                newReededFilmTexture.needsUpdate = true;

                const reededMesh = new THREE.Mesh(reededGeometry, newReededMaterial)
                reededMesh.position.x = reeded.position.x;
                reededMesh.position.y = reeded.position.y;
                reededMesh.position.z = reeded.position.z;
                scene.add(reededMesh);
                removableMeshes.push(reededMesh.uuid);
            }
        }

        /**
         * Logo Cutout
         */
        if (buildJSON.office.manifestations.logocutouts !== undefined) {
            for (let logoCutoutKey in buildJSON.office.manifestations.logocutouts) {
                let logoCutOut = buildJSON.office.manifestations.logocutouts[logoCutoutKey];
                //console.log(logoCutOut);

                let logoManifestationScale = 1;
                let thisLogoCutout = mgoLogoManifestation.clone();
                thisLogoCutout.scale.set(logoManifestationScale, logoManifestationScale, logoManifestationScale)

                thisLogoCutout.position.x = logoCutOut.position.x;
                thisLogoCutout.position.y = logoCutOut.position.y;
                thisLogoCutout.position.z = logoCutOut.position.z;

                let logoCutoutOrientation = 'x';
                if (logoCutOut.size.depth > logoCutOut.size.width) {
                    logoCutoutOrientation = 'z';
                }

                if (((logoCutoutOrientation === 'x') && (logoCutOut.size.width < 0.5)) || ((logoCutoutOrientation === 'z') && (logoCutOut.size.depth < 0.5))) {
                    //There's not enough space for a logo, add a filler instead
                    const fillerGeometry = new THREE.BoxGeometry(logoCutOut.size.width, logoCutOut.size.height, logoCutOut.size.depth);
                    removableGeometries.push(fillerGeometry.uuid);

                    const fillerMesh = new THREE.Mesh(fillerGeometry, frostedGlassMaterial);
                    fillerMesh.position.x = logoCutOut.position.x;
                    fillerMesh.position.y = logoCutOut.position.y;
                    fillerMesh.position.z = logoCutOut.position.z;
                    scene.add(fillerMesh);
                    removableMeshes.push(fillerMesh.uuid);
                } else {
                    thisLogoCutout.rotation.x = Math.PI * 1.5;
                    if (logoCutoutOrientation === 'z') {
                        thisLogoCutout.rotation.z = Math.PI * 1.5;
                    }

                    scene.add(thisLogoCutout);
                    removableMeshes.push(thisLogoCutout.uuid);

                    let logoWidth = logoCutOut.size.width;
                    let logoDepth = logoCutOut.size.depth;

                    // Cutout is 0.5m wide, so anything over 0.5 we need to pad
                    let logoRemainder = logoWidth - 0.5;

                    if (logoCutoutOrientation === 'z') {
                        logoRemainder = logoDepth - 0.5;
                    }

                   // console.log('logoCutoutOrientation: ' + logoCutoutOrientation);
                   // console.log('logoRemainder: ' + logoRemainder);

                    if (logoRemainder >= 0) {

                        if (logoCutoutOrientation === 'x') {

                            const leftWingGeometry = new THREE.BoxGeometry(logoRemainder / 2, logoCutOut.size.height, logoDepth);
                            removableGeometries.push(leftWingGeometry.uuid);

                            const leftWingMesh = new THREE.Mesh(leftWingGeometry, frostedGlassMaterial);

                            leftWingMesh.position.x = logoCutOut.position.x - (logoRemainder / 2 / 2) - 0.25;
                            leftWingMesh.position.y = logoCutOut.position.y;
                            leftWingMesh.position.z = logoCutOut.position.z;
                            scene.add(leftWingMesh);
                            removableMeshes.push(leftWingMesh.uuid);

                            const rightWingGeometry = new THREE.BoxGeometry(logoRemainder / 2, logoCutOut.size.height, logoDepth);
                            removableGeometries.push(rightWingGeometry.uuid);

                            const rightWingMesh = new THREE.Mesh(rightWingGeometry, frostedGlassMaterial);

                            rightWingMesh.position.x = logoCutOut.position.x + (logoRemainder / 2 / 2) + 0.25;
                            rightWingMesh.position.y = logoCutOut.position.y;
                            rightWingMesh.position.z = logoCutOut.position.z;
                            scene.add(rightWingMesh);
                            removableMeshes.push(rightWingMesh.uuid);
                        }

                        if (logoCutoutOrientation === 'z') {

                            const leftWingGeometry = new THREE.BoxGeometry(logoWidth, logoCutOut.size.height, logoRemainder / 2);
                            removableGeometries.push(leftWingGeometry.uuid);

                            const leftWingMesh = new THREE.Mesh(leftWingGeometry, frostedGlassMaterial);

                            leftWingMesh.position.x = logoCutOut.position.x;
                            leftWingMesh.position.y = logoCutOut.position.y;
                            leftWingMesh.position.z = logoCutOut.position.z - (logoRemainder / 2 / 2) - 0.25;
                            scene.add(leftWingMesh);
                            removableMeshes.push(leftWingMesh.uuid);

                            const rightWingGeometry = new THREE.BoxGeometry(logoWidth, logoCutOut.size.height, logoRemainder / 2);
                            removableGeometries.push(rightWingGeometry.uuid);

                            const rightWingMesh = new THREE.Mesh(rightWingGeometry, frostedGlassMaterial);

                            rightWingMesh.position.x = logoCutOut.position.x;
                            rightWingMesh.position.y = logoCutOut.position.y;
                            rightWingMesh.position.z = logoCutOut.position.z + (logoRemainder / 2 / 2) + 0.25;
                            scene.add(rightWingMesh);
                            removableMeshes.push(rightWingMesh.uuid);
                        }

                    }

                }
            }
        }

    }

    /**
     * Lights
     */
    const lightsBeacon = document.getElementById('configurator-lights-beacon');
    let beaconStyle = window.getComputedStyle(lightsBeacon);

    if (beaconStyle.display === 'block') {
        if (buildJSON.scene.lights !== undefined) {

            for (let lightKey in buildJSON.scene.lights) {
                let light = buildJSON.scene.lights[lightKey];

                const spotLight = new THREE.SpotLight('#ffffff');
                spotLight.position.x = light.position.x;
                spotLight.position.y = light.position.y;
                spotLight.position.z = light.position.z;

                spotLight.penumbra = light.settings.penumbra;
                spotLight.intensity = light.settings.intensity;
                spotLight.angle = light.settings.angle;

                spotLight.target.position.set(light.position.x, 0, light.position.z);
                scene.add(spotLight.target);
                removableLights.push(spotLight.target.uuid);
                scene.add(spotLight);
                removableLights.push(spotLight.uuid);

                // const spotLightHelper = new THREE.SpotLightHelper( spotLight );
                // scene.add( spotLightHelper );
            }
        }
    }

    /**
     * Objects
     */
    if (buildJSON.office.objects !== undefined) {
        for (let objectKey in buildJSON.office.objects) {
            let object = buildJSON.office.objects[objectKey];

            if (object.type === 'conferencetable1') {
                if (conferenceTableClean !== undefined) {
                    let tableScale = 0.25;
                    let thisTable = conferenceTableClean.clone();
                    thisTable.scale.set(tableScale, tableScale, tableScale)
                    thisTable.position.x = object.position.x;
                    thisTable.position.z = (object.position.z);
                    scene.add(thisTable);
                    removableObjects.push(thisTable.uuid);
                }
            }

            if (object.type === 'conferencetable2') {
                if (conferenceTableBrick !== undefined) {
                    let tableScale = 0.25;
                    let thisTable = conferenceTableBrick.clone();
                    thisTable.scale.set(tableScale, tableScale, tableScale)
                    thisTable.position.x = object.position.x;
                    thisTable.position.z = (object.position.z);
                    scene.add(thisTable);
                    removableObjects.push(thisTable.uuid);
                }
            }

            if (object.type === 'smalldesk1') {
                if (smallDeskClean !== undefined) {
                    let deskScale = 0.25;
                    let thisDesk = smallDeskClean.clone();
                    thisDesk.scale.set(deskScale, deskScale, deskScale)
                    thisDesk.position.x = object.position.x;
                    thisDesk.position.z = object.position.z;
                    thisDesk.rotation.y = Math.PI * 1.5;
                    scene.add(thisDesk);
                    removableObjects.push(thisDesk.uuid);
                }
            }

            if (object.type === 'smalldesk2') {
                if (smallDeskBrick !== undefined) {
                    let deskScale = 0.25;
                    let thisDesk = smallDeskBrick.clone();
                    thisDesk.scale.set(deskScale, deskScale, deskScale)
                    thisDesk.position.x = object.position.x;
                    thisDesk.position.z = object.position.z;
                    thisDesk.rotation.y = Math.PI * 1.5;
                    scene.add(thisDesk);
                    removableObjects.push(thisDesk.uuid);
                }
            }

            if (object.type === 'poster') {
                const posterGeometry = new THREE.BoxGeometry(object.size.width, object.size.height, object.size.depth);
                removableGeometries.push(posterGeometry.uuid);

                const posterMesh = new THREE.Mesh(posterGeometry, posterMaterial)
                posterMesh.position.x = object.position.x;
                posterMesh.position.y = object.position.y;
                posterMesh.position.z = object.position.z;
                scene.add(posterMesh)
                removableObjects.push(posterMesh.uuid);
            }
        }
    }

    console.log('Scene fully loaded');
    if (initialLoadDone === false) {
        console.log('Initial load done');
        initialLoadDone = true;
    }
    loadingOverlay.classList.remove('active');
}

let clearObjectFromArray = function (array) {
    array.map((i)=> {
        let object = scene.getObjectByProperty('uuid', i);
        if (object !== undefined) {
            if (object.hasOwnProperty('dispose')) {
                object.dispose();
            }
            scene.remove(object);
        }
    });
};

let clearScene = function () {
    console.log('Clearing Scene');
    clearObjectFromArray(removableGeometries);
    clearObjectFromArray(removableMeshes);
    clearObjectFromArray(removableMaterials);
    clearObjectFromArray(removableTextures);
    clearObjectFromArray(removableObjects);
    clearObjectFromArray(removableLights);
}

/**
 * Get initial config and build
 */
const jsonDOMObject = document.getElementById("renderdata");
const buildData = jsonDOMObject.innerText;
let buildJSON = {};
if (buildData !== '') {
    buildJSON = JSON.parse(buildData);
}
let jsonDOMObjectKey = undefined;

/**
 * Resize Listener
 */
window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = renderHolder.offsetWidth;
    sizes.height = renderHolder.offsetHeight;

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    preserveDrawingBuffer: false,
    powerPreference: 'high-performance',
    antialias: false,
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

//Expose the renderer for access elsewhere
window.ThreeRenderer = renderer;

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () => {
    //const elapsedTime = clock.getElapsedTime()
    //buildJSON = JSON.parse(jsonDOMObject.innerHTML);

    // stats.begin

    if (
        guardsmanHandle750 !== undefined
        && guardsmanHandle1200 !== undefined
        && guardsmanCrankedHandle720 !== undefined
        && guardsmanCrankedHandle1240 !== undefined
        && dHandleCranked600 !== undefined
        && dHandleCranked1000 !== undefined
        && leverHandleTimber !== undefined
        && leverHandleFramed !== undefined
        && leverHandleGlass !== undefined
        && leverHandleGlassStrikerBox !== undefined
        && dHandle600 !== undefined
        && dHandle1000 !== undefined
        && buttHinge !== undefined
        && plateHinge !== undefined
        && topPivot !== undefined
        && bottomPivot !== undefined
        && pivotFrameLeft !== undefined
        && pivotFrameRight !== undefined
        && slidingDoorRail !== undefined
        && doorCloserTimber !== undefined
        && doorCloserHidden !== undefined
        && mgoLogoManifestation !== undefined
        && floorCleanColorTextureLoaded !== undefined
        && floorBrickColorTextureLoaded !== undefined
        && wallBrickColorTextureLoaded !== undefined
        && ceilingBrickColorTextureLoaded !== undefined
        && ceilingCleanColorTextureLoaded !== undefined
        && oakDoorMapTextureLoaded !== undefined
        && mapleDoorMapTextureLoaded !== undefined
        && walnutDoorMapTextureLoaded !== undefined
        && posterColorTextureLoaded !== undefined
    ) {
        essentialModelsLoaded = true;
    }

    if (essentialModelsLoaded === true) {
        let currentDataVersion = jsonDOMObject.getAttribute('data-version');
        if (((currentDataVersion !== jsonDOMObjectKey) && (currentDataVersion !== "-1")) || (lazyLoadedRedrawNeeded === true && initialLoadDone === true)) {
            lazyLoadedRedrawNeeded = false;
            jsonDOMObjectKey = jsonDOMObject.getAttribute('data-version');
            buildJSON = JSON.parse(jsonDOMObject.innerHTML);
            clearScene();
            buildSceneFromJSON(buildJSON);
        }
    }

    if (essentialModelsLoaded === true && initialLoadDone === true) {
        // Update controls
        controls.update();

        // Render
        renderer.render(scene, camera);
    }

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)

    // stats.end()
}

tick();
